import { FOCUS_1_PAGE, FOCUS_2_PAGE, FOCUS_3_PAGE } from '@/constants/pagesUrl';

const dropdown = {
  button: 'Our focus',
  list: [
    {
      text: 'Focus 1',
      href: FOCUS_1_PAGE,
    },
    {
      text: 'Focus 2',
      href: FOCUS_2_PAGE,
    },
    {
      text: 'Focus 3',
      href: FOCUS_3_PAGE,
    },
  ],
};

export default dropdown;
